import React from "react";
import "./mobile.css";
import "./styles.css";
/**
 * @function WidgetContainer
 * @param {STRING} className - Allows us to set a custom class for each WidgetContainer. 
 * @param {React.Component} children - Allows us to inject other components.
 * @returns {React.Component}
 * @example
 * <WidgetContainer className="some-class">
 *  <WidgetView/>
 * </WidgetContainer>
 */
export default function WidgetContainer(props) {
  const className = props.className ?? "";
  return (
    <div className={`${className} widget-container flex-container flex-vertical`}>
      {props.children}
    </div>
  );
}